import { Message } from 'element-ui';

export function validateEmpty(str) {
  return str && str.trim();
}

/* 合法uri*/
export function validateURL(textval) {
  const urlregex =
    /^(https?|ftp):\/\/([a-zA-Z0-9.-]+(:[a-zA-Z0-9.&%$-]+)*@)*((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9][0-9]?)(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|([a-zA-Z0-9-]+\.)*[a-zA-Z0-9-]+\.(com|edu|gov|int|mil|net|org|biz|arpa|info|name|pro|aero|coop|museum|[a-zA-Z]{2}))(:[0-9]+)*(\/($|[a-zA-Z0-9.,?'\\+&%$#=~_-]+))*$/;
  return urlregex.test(textval);
}

/* 小写字母*/
export function validateLowerCase(str) {
  const reg = /^[a-z]+$/;
  return reg.test(str);
}

/* 大写字母*/
export function validateUpperCase(str) {
  const reg = /^[A-Z]+$/;
  return reg.test(str);
}

/* 大小写字母*/
export function validateAlphabets(str) {
  const reg = /^[A-Za-z]+$/;
  return reg.test(str);
}

/* 手机号*/
export function validatPhone(str) {
  const reg = /^1[3456789]\d{9}$/;
  return reg.test(str);
}

/* 账号*/
export function validateAccount(str) {
  const reg = /^[a-zA-Z\d]\w{3,19}[a-zA-Z\d]$/;
  return reg.test(str);
}

/* Email地址*/
export function validateEmail(str) {
  const reg = /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]+$/;
  return reg.test(str);
}

/* 域名校验*/
export function validateDomain(str) {
  var reg =
    /^(?=^.{3,255}$)[a-zA-Z0-9][-a-zA-Z0-9]{0,62}(\.[a-zA-Z0-9][-a-zA-Z0-9]{0,62})+$/;
  return reg.test(str);
}

/* 企业名称*/
export function validateEnterpriseName(str) {
  const reg = /^(?!_|\-)(?!.*?_$)(?!.*?-$)[a-zA-Z0-9_\-\u4e00-\u9fa5]+$/;
  return reg.test(str);
}
/* 重定向*/
export function validateRedirect(str) {
  if (
    // 如果在redirect中存在以下信息，就跳转到manage页面。
    !str ||
    str == undefined ||
    str.indexOf('login') != -1 ||
    str.indexOf('register') != -1 ||
    str.indexOf('appstore') != -1 ||
    str.indexOf('forgetPassword') != -1
  ) {
    return '/manage/overview/';
  } else {
    return str;
  }
}
/* 时间*/
export function timetrans(dates) {
  if (dates && dates.indexOf('0001-01') > -1) {
    return '-';
  }
  const deter = new Date(dates).getTime();

  const date = new Date(deter); // 如果date为13位不需要乘1000
  const Y = date.getFullYear() + '-';
  const M =
    (date.getMonth() + 1 < 10
      ? '0' + (date.getMonth() + 1)
      : date.getMonth() + 1) + '-';
  const D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
  const h =
    (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
  const m =
    (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
    ':';
  const s =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds();
  const times = Y + M + D + h + m + s;
  return times;
}

/* 过滤Nnumber*/
export function numFilter(num, decimal) {
  if (num) {
    return num.toFixed(decimal || 0) + '元';
  }
  return '0';
}

function messages(msg, type = 'warning') {
  return Message({
    message: msg,
    type,
    duration: 5 * 1000
  });
}

export function validateEname(code, error) {
  switch (code) {
    case 500:
      return messages('系统异常！', 'error');
    case 1001:
      return messages('企业名称已存在', 'errorDomainMsg');
    case 1002:
      return error('企业域已存在', 'errorDomainMsg');
    case 3003:
      return error('企业名称已存在', 'errorEnameMsg');

    default:
      return null;
  }
}
export function validateRegistered(code, error) {
  switch (code) {
    case 500:
      return messages('系统异常！', 'error');
    case 1000:
      return messages('企业已存在（名称或域名已存在）');
    case 1001:
      return messages('企业名称已存在');
    case 3003:
      return error('邮箱已注册', 'errorEmailMsg');
    case 3004:
      return error('手机已注册', 'errorPhoneMsg');
    case 2001:
      return error('短信验证码不正确', 'errorVerificationMsg');
    case 2003:
      return messages('图片验证码不正确');
    case 2005:
      return error('短信验证码超时或过期', 'errorVerificationMsg');
    default:
      return messages('注册异常');
  }
}
export function validateImgCode(code, error) {
  if (code == 2002) {
    return error('图片验证码不正确', 'errorVerificationMsg');
  }
}
export function validateResetPasswordCode(code, error) {
  switch (code) {
    case 3001:
      return error('账户不存在', 'errorUserMsg');
    case 2001:
      return error('短信验证码不正确', 'errorValidationrMsg');
    case 2005:
      return error('短信验证码超时', 'errorValidationrMsg');
    default:
      return null;
  }
}



// WEBPACK FOOTER //
// ./src/utils/validate.js